The pagination metadata for this page of advertisement brandings.
